const articleData = [
  {
    img:"https://hdwallsource.com/img/2018/2/wikipedia-logo-wallpaper-63039-65059-hd-wallpapers.jpg",
    article:"https://en.wikipedia.org/wiki/Golden_ratio"
  },
  {
    img:"https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSQmpqm_I76alhZPXYtw8U53B1UGKlqe6IwgA&usqp=CAU",
    article:"https://mathworld.wolfram.com/GoldenRatio.html"
  },
  {
    img:`${process.env.PUBLIC_URL + '/phi.png'}`,
    article:"https://www.goldennumber.net/golden-ratio/"
  }
];
export {articleData};